import { PageTypeRestrict } from '~/app/routes';
import { PlatformRolePermissions, PlatformRolePermissionKey } from '~/repositories';

export const checkIfRestricted = (permissions: PlatformRolePermissions, restrictIf: PageTypeRestrict) => {
  for (const objKey in restrictIf) {
    if (permissions.hasOwnProperty(objKey)) {
      const key = objKey as PlatformRolePermissionKey;
      const value = permissions[key];

      if (typeof value !== 'undefined' && !restrictIf[key]?.includes(value)) {
        return false;
      }
    } else {
      return false;
    }
  }
  return true;
};
